<template>
  <div class="restore-password-page flex-grow-1">
    <b-container
      class="d-flex justify-content-center align-items-center flex-column h-100"
    >
      <h3 align="center" class="mb-4">Восстановление пароля</h3>
      <b-form
        class="auth-form"
        @submit.prevent="onResetPassword"
        v-if="showForm"
      >
        <p class="text-center">Введите новый пароль</p>

        <b-overlay
          :show="loader"
          rounded="sm"
          variant="white"
          opacity=".35"
          blur="4px"
          class=""
        >
          <b-form-group id="input-group-2" label-for="input-2">
            <b-form-input
              id="input-2"
              type="password"
              v-model="$v.form.password.$model"
              placeholder="Пароль"
              :state="validateState('password')"
            ></b-form-input>
            <b-form-invalid-feedback v-if="!$v.form.password.required"
              >Необходимо ввести пароль</b-form-invalid-feedback
            >
            <b-form-invalid-feedback v-if="!$v.form.password.minLength"
              >Минимальная длина пароля:
              {{ $v.form.password.$params.minLength.min }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-button type="submit" variant="warning" size="lg" block
            >Изменить</b-button
          >
        </b-overlay>
      </b-form>
      <template v-else>
        <p>{{ errorMessage }}</p>
      </template>
      <p class="text-center pt-4">
        <router-link to="/login" class="btn btn-link text-secondary"
          >На страницу входа</router-link
        >
      </p>
    </b-container>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      showForm: false,
      loader: false,
      form: {
        password: ''
      },
      showAlert: false,
      errorMessage: ''
    };
  },
  validations: {
    form: {
      password: { required, minLength: minLength(6) }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onResetPassword() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        this.$v.$touch();
        return;
      }

      this.loader = true;

      try {
        this.errorMessage = '';
        const response = await this.$store.dispatch('resetPassword', {
          form: this.form,
          token: this.$route.params.t
        });
        if (response) {
          this.showForm = false;
          this.$toast('Пароль успешно изменен!', {
            title: 'Пароль сохранен',
            variant: 'success'
          });
          this.errorMessage = 'Теперь вы можете войти в личный кабинет';
          this.form.password = '';
          this.$v.$reset();
          this.loader = false;
        }
      } catch (e) {
        this.loader = false;
      }
    }
  },
  async mounted() {
    this.errorMessage = '';
    try {
      const token = this.$route.params.t;
      console.log(token);
      const response = await this.$store.dispatch(
        'userByResetPasswordToken',
        token
      );
      if (response) {
        this.showForm = true;
      }
    } catch (e) {
      this.errorMessage = 'Ошибка при попытке изменить пароль';
    }
  }
};
</script>

<style lang="scss" scoped>
.restore-password-page {
  background-color: #f5f5f5;
}
</style>
